const pageNameKey = "unassignedFilterViewTitleIgnoreAllButtonWrapper";

export const unassignedFilterViewTitleIgnoreAllButtonWrapperEn = {
  [pageNameKey]: {
    openIssuesTitle: "Open Issues",
    ignoreAllButton: "Ignore All Issues",
  },
};

export const unassignedFilterViewTitleIgnoreAllButtonWrapperPtBr = {
  [pageNameKey]: {
    openIssuesTitle: "Problemas em aberto",
    ignoreAllButton: "Ignorar todos os problemas",
  },
};

export const unassignedFilterViewTitleIgnoreAllButtonWrapperDe = {
  [pageNameKey]: {
    openIssuesTitle: "Offene Probleme",
    ignoreAllButton: "Alle Probleme ignorieren",
  },
};

export const unassignedFilterViewTitleIgnoreAllButtonWrapperZhHans = {
  [pageNameKey]: {
    openIssuesTitle: "未分配问题",
    ignoreAllButton: "忽略所有问题",
  },
};

export const unassignedFilterViewTitleIgnoreAllButtonWrapperIt = {
  [pageNameKey]: {
    openIssuesTitle: "Issue aperte",
    ignoreAllButton: "Ignora tutti i problemi",
  },
};

export const unassignedFilterViewTitleIgnoreAllButtonWrapperEs = {
  [pageNameKey]: {
    openIssuesTitle: "Problemas abiertos",
    ignoreAllButton: "Ignorar todos los problemas",
  },
};

export const unassignedFilterViewTitleIgnoreAllButtonWrapperNl = {
  [pageNameKey]: {
    ignoreAllButton: "Alle problemen negeren",
    openIssuesTitle: "Openstaande problemen",
  },
};

export const unassignedFilterViewTitleIgnoreAllButtonWrapperTr = {
  [pageNameKey]: {
    ignoreAllButton: "Tüm Sorunları Yoksay",
    openIssuesTitle: "Açık Sayılar",
  },
};
